import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { reportErrorToSlack } from "./utils/report";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallBack from "./pages/error/ErrorFallBack";
import { useModal } from "./utils/useModal";
import { usePreventContextMenu } from "./utils/usePreventContextMenu";

const loading = <></>;

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages

//컴포넌트
const App = () => {
  const { openModal } = useModal();
  usePreventContextMenu();

  useEffect(() => {
    /**
     * 네이티브 iOS 사진 권한 체크 함수
     */
    // const addPhoto = () => {
    //   try {
    //     window.webkit?.messageHandlers?.addPhoto.postMessage("");
    //   } catch (e: any) {
    //     console.log(e);
    //     alert(e.message);
    //   }
    // };

    const iOSAlert = (message: string) => {
      openModal({ type: "guide", message: message });
    };

    /**
     * FCM 토큰 받아와서 LocalStorage에 할당
     * @param token 저장할 토큰 값
     */
    const getFcmToken = (token: string) => {
      if (!token) return;
      localStorage.setItem("fcmToken", token);
    };

    window.requestIOSError = iOSAlert;
    window.getFcmToken = getFcmToken;
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary
        key={location.pathname}
        FallbackComponent={ErrorFallBack}
        onError={reportErrorToSlack}
      >
        <Suspense fallback={loading}>
          <Routes>
            <Route path="/*" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
